<template>
  <v-card class="pa-0 ma-0 mt-9 pa-8">
    <v-card-title class="ma-0 pa-0 h6 blue-grey--text text--darken-2 mb-1">
      {{ $t('boards.setup_your_columns') }}
    </v-card-title>
    <v-card-text class="ma-0 pa-0 pb-4">
      <p class="body-2 blue-grey--text text-darken-1 mb-4">
        {{ $t('boards.columns_step_description') }}
      </p>
      <v-form v-model="formIsValid" ref="columnsForm" lazy-validation>
        <Draggable
          ghost-class="ghost-item"
          handle=".column-drag-control"
          :list="columns"
          @change="handleDrag"
        >
          <v-card
            v-for="(column, index) in columns"
            outlined
            class="board-column-container mb-4"
            :key="`column-${index}-pos${column.position}`"
          >
            <div
              class="d-flex align-start justify-space-between py-0 mb-2 mt-2 mx-3"
            >
              <div></div>
              <v-icon
                color="blue-grey"
                size="24"
                class="column-drag-control drag_indicator_icon_rotated mt-n2"
                >drag_indicator</v-icon
              >
              <v-icon
                v-if="columns.length > 1"
                color="blue-grey darken-3"
                size="16"
                @click="deleteColumn(column)"
                >mdi-close</v-icon
              >
              <div v-else style="width: 16px; height: 16px"></div>
            </div>
            <ColumnForm
              class="mx-6 mb-2"
              :column="column"
              @change="handleFiltersChange($event, index)"
            />
          </v-card>
        </Draggable>
      </v-form>
      <AddColumnButton @add="handleAddColumn" />
    </v-card-text>
    <v-card-actions class="ma-0 pa-0 mt-4 justify-space-between">
      <v-btn text plain rounded dense color="blue" @click="$emit('back')">{{
        $t('common.button.back')
      }}</v-btn>
      <div>
        <v-btn
          text
          plain
          rounded
          dense
          color="blue-grey darken-1"
          @click="$emit('cancel')"
          >{{ $t('common.button.cancel') }}</v-btn
        >
        <v-btn
          rounded
          dense
          color="blue"
          elevation="0"
          class="white--text px-4 ms-3"
          @click="handleContinue"
          >{{ $t('common.button.continue') }}</v-btn
        >
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import Draggable from 'vuedraggable'

import ColumnForm from '@/components/CreateBoardColumn/ColumnForm.vue'
import AddColumnButton from '@/components/CreateBoardColumn/AddColumnButton.vue'

import trackerMixin from '@/mixins/tracking/trackerMixin.vue'

export default {
  name: 'AddColumnsStep',

  components: { ColumnForm, AddColumnButton, Draggable },

  mixins: [trackerMixin],

  data() {
    return {
      formIsValid: true,
      columns: [this.$constants.EMPTY_COLUMN],
    }
  },

  watch: {
    formIsValid: {
      handler(formIsValid) {
        this.$emit('formIsValid', formIsValid)
      },
    },
  },

  methods: {
    validate() {
      const isValid = this.$refs.columnsForm.validate()
      this.$emit('formIsValid', isValid)
      return isValid
    },

    handleAddColumn() {
      this.columns.push({
        ...this.$constants.EMPTY_COLUMN,
        position: this.columns.length,
      })
      setTimeout(() => this.validate(), 500)
      this.trackBoardsActions('boards.AddColumnCreationBoard')
    },

    handleContinue() {
      this.validate()
      this.$emit('continue')
    },

    handleDrag() {
      this.columns = this.columns.map((column, index) => {
        return {
          ...column,
          position: index,
        }
      })
      this.trackBoardsActions('boards.DragAndDropColumn', {
        section: 'create new board',
      })
      this.$emit('change', this.columns)
    },

    handleFiltersChange(filtersChanged, index) {
      this.handleChange(filtersChanged, index)
      this.trackBoardsActions('boards.FiltersChangeCreationBoard', {
        filters: filtersChanged,
      })
    },

    handleChange(columnChange, index) {
      this.columns[index] = { ...this.columns[index], ...columnChange }
      this.$emit('change', this.columns)
    },

    deleteColumn(deletedColumn) {
      this.columns = this.columns
        .filter(column => column.position !== deletedColumn.position)
        .map((column, index) => {
          return {
            ...column,
            position: index,
          }
        })
      this.$emit('change', this.columns)
      this.trackBoardsActions('boards.DeleteColumnCreationBoard')
    },
  },
}
</script>

<style lang="scss" scoped>
.drag_indicator_icon_rotated {
  transform: rotate(90deg);
}

.ghost-item {
  opacity: 0.5;
}

.board-column-container {
  .column-drag-control {
    cursor: move;
    visibility: hidden;
  }

  &:hover {
    .column-drag-control {
      visibility: visible;
    }
  }
}
</style>
